const BASE    = process.env.REACT_APP_URL || "http://127.0.0.1:8000";
const API_KEY = process.env.REACT_APP_API_KEY;

export const apiHeaders = () => ({
  "Content-Type": "application/json",
  ...(API_KEY ? { "x-api-key": API_KEY } : {}),
  "ngrok-skip-browser-warning": "true",
});

/** Generic PSX API fetch */
export async function makeApiRequest(path) {
  const url = `${BASE}/${path}`;
  const res = await fetch(url, { headers: apiHeaders() });
  if (!res.ok) throw new Error(`API error ${res.status}: ${url}`);
  return res.json();
}

/** Convert a Unix-second timestamp to YYYY-MM-DD */
export function tsToDate(ts) {
  return new Date(ts * 1000).toISOString().split("T")[0];
}

/** Fetch all PSX symbols (handles paginated or plain array response) */
export async function fetchPSXSymbols() {
  const data = await makeApiRequest("api/symbols/");
  return Array.isArray(data) ? data : data.results || [];
}
